export class ValueWithTranslatedLabel {

  public value: string;

  public translatedLabel: string;

  static fromDto(t: any): ValueWithTranslatedLabel {
    const valueWithTranslatedLabel = new ValueWithTranslatedLabel();

    if (!t) {
      return null;
    }

    valueWithTranslatedLabel.value               = t.value;
    valueWithTranslatedLabel.translatedLabel     = t.translated_label;

    return valueWithTranslatedLabel;
  }
}
